export const messages = {
    invoice: {
        date: 'Datum',
        dueDate: 'Vervaldatum',
        paymentTerms: 'Betalingstermijn',
        paymentDays: 'Aantal dagen',
        days: 'dagen',
        workingDraft: 'Concept',
        invoiceFor: 'Factuur voor {company}',
        pagination: 'Pagina {page} van {total}',
        lineItems: {
            description: 'Omschrijving',
            quantity: 'Aantal',
            price: 'Prijs',
            vatRate: 'BTW',
            amount: 'Bedrag',
            add: 'Item toevoegen',
            remove: 'Verwijderen',
        },
        subtotal: 'Subtotaal',
        vat: 'BTW',
        total: 'Totaal',
        status: 'Status',
        discount: {
            add: 'Korting toevoegen',
            display: 'Korting: {value}',
            percentage: 'Percentage',
            fixed: 'Vast bedrag',
            none: 'Geen korting',
            label: 'Korting',
            edit: 'Korting bewerken'
        },
        from: 'Van',
        to: 'Aan',
        number: 'Factuurnummer',
        notes: 'Notities',
        company: 'Bedrijf',
        address: 'Adres',
        postalCode: 'Postcode',
        city: 'Plaats',
        additionalInfo: 'Extra Informatie',
        vatNumber: 'BTW-nummer',
        kvkNumber: 'KvK-nummer',
        kvk: 'KvK',
        btw: 'BTW',
        title: 'FACTUUR',
        nonEditableTitle: 'Factuur kan niet bewerkt worden',
        sentNonEditableMessage: 'Deze factuur is verzonden en kan niet meer worden bewerkt om de integriteit van de gegevens te behouden.',
        paidNonEditableMessage: 'Deze factuur is betaald en kan niet meer worden bewerkt om de integriteit van de gegevens te behouden.',
        useCommandBarMessage: 'Je kunt de geschiedenis bekijken of de factuur verwijderen via de commandobalk hieronder.',
        history: {
            created: 'Factuur aangemaakt',
            createdDescription: 'Factuur #{invoiceNumber} is aangemaakt',
            saved: 'Factuur opgeslagen',
            savedDescription: 'Factuur is opgeslagen en is klaar om te worden verzonden',
            updated: 'Factuur gewijzigd',
            updatedDescription: 'Factuurgegevens zijn gewijzigd',
            paymentReceived: 'Betaling is ontvangen voor deze factuur',
            paymentReceivedFromProvider: '{provider} betaling ontvangen',
            paymentReceivedFromProviderDescription: 'Betaling is verwerkt door {provider}',
            markedPaidDescription: 'Factuur is als betaald gemarkeerd',
            overdueDescription: 'Factuur werd achterstallig op de vervaldatum',
            reminderSent: 'Betalingsherinnering Verzonden',
            reminderSentDescription: 'Betalingsherinnering is verzonden naar {email}',
            subtitle: 'Activiteitenhistorie voor deze factuur',
            loadError: 'Kan geschiedenis niet laden',
            loadErrorDescription: 'We hebben een probleem ondervonden bij het laden van je factuurgeschiedenis.',
            empty: 'Nog geen geschiedenis',
            emptyDescription: 'Je factuurgeschiedenis verschijnt hier wanneer er wijzigingen worden aangebracht en e-mails worden verzonden.'
        },
        paymentMethods: {
            title: 'Betaalmethode',
            add: 'Betaalmethode toevoegen',
            edit: 'Betaalmethode bewerken',
            none: 'Geen',
            enabled: 'Deze betaalmethode inschakelen',
            online: 'Betaal deze factuur online:',
            alternative: 'Of betaal deze factuur online:',
            onlineOnly: 'Betaal deze factuur binnen {days} dagen via de beveiligde optie hieronder:',
            notSure: 'Niet zeker of je hebt betaald? Check de status hier',
            payNow: 'Nu Betalen',
            setAsDefault: 'Toevoegen als standaard voor toekomstige facturen',
            bank: {
                title: 'Bankoverschrijving',
                iban: 'IBAN',
                bic: 'BIC/SWIFT (optioneel)',
                accountName: 'Rekeninghouder',
                paymentInstructionWithDays: 'Wij verzoeken u vriendelijk om binnen {days} dagen te betalen aan:',
                reference: 'Referentie',
                includeReference: 'Vermeld het referentienummer bij uw betaling'
            },
            paypal: {
                title: 'PayPal',
                email: 'PayPal E-mail'
            },
            mollie: {
                title: 'Mollie',
                apiKey: 'Mollie API Sleutel',
                description: 'Betalingsomschrijving',
                connected: 'Verbonden met Mollie',
                reconnect: 'Opnieuw verbinden',
                connect: 'Verbind met Mollie',
                connecting: 'Verbinden...',
                explain: 'Verbind je Mollie-account om online betalingen direct via je facturen te accepteren',
                readyToReceive: 'Klaar om online betalingen te ontvangen'
            },
            stripe: {
                title: 'Stripe',
                accountId: 'Stripe Account ID',
                description: 'Betalingsomschrijving'
            }
        },
        saveAsDefault: 'Opslaan als standaard voor nieuwe facturen',
        paymentDate: 'Betaald gemarkeerd op',
        languageNotice: 'Je interface is in het {interfaceLanguage}, maar de factuurvoorbeeld en e-mail worden verzonden in het {invoiceLanguage}',
    },
    overlay: {
        recently: 'Onlangs',
        paymentReceived: 'Betaling ontvangen',
        invoiceSent: 'Factuur verzonden',
        readOnly: 'Read-only',
        editingDisabled: 'Bewerken is uitgeschakeld'
    },
    status: {
        concept: 'Concept',
        saved: 'Opgeslagen',
        sent: 'Verzonden',
    },
    payment: {
        status: {
            unpaid: 'Openstaand',
            paid: 'Betaald',
            markedPaid: 'Als betaald gemarkeerd',
            overdue: 'Te laat',
            overdue_reminded: 'Herinnerd',
            reminderSent: 'Herinnering verstuurd {date}',
            canceled: 'Geannuleerd',
            failed: 'Mislukt'
        },
        updateStatus: 'Betalingsstatus bijwerken',
        filter: {
            all: 'Alle facturen',
            planned: 'Gepland'
        }
    },
    errors: {
        pdfGenerationFailed: 'PDF genereren mislukt. Probeer het opnieuw.',
    },
    actions: {
        actions: 'Acties',
        generatingPDF: 'PDF genereren...',
        exportPDF: 'Exporteer PDF',
        new: 'Nieuwe Factuur',
        saveInvoice: 'Factuur Opslaan',
        sendInvoice: 'Factuur Verzenden',
        previewSend: 'Verzendvoorbeeld',
        delete: 'Verwijderen',
        save: 'Opslaan',
        cancel: 'Annuleren',
        confirm: 'Bevestigen',
        copy: 'Kopiëren',
        download: 'Downloaden',
        send: 'Verzenden',
        close: 'Sluiten',
        clickToEdit: 'Klik om te bewerken',
        done: 'Klaar',
        sendReminder: 'Herinnering Versturen',
        sendingReminder: 'Herinnering Versturen...',
        reminderSent: 'Herinnering Verzonden',
        reminderCooldown: 'Volgende herinnering beschikbaar over {hours}u {minutes}m'
    },
    settings: {
        title: 'Instellingen',
        language: 'Taal',
        invoiceLanguage: 'Facturen versturen in taal:',
        country: 'Standaard BTW-land',
        logo: {
            title: 'Bedrijfslogo',
            placeholder: 'Upload een bedrijfslogo',
            dropHere: 'Laat je logo hier vallen',
            clickOrDrop: 'Klik of sleep logo',
            uploading: 'Logo uploaden...',
            invalidType: 'Ongeldig bestandstype. Alleen JPG, PNG, WEBP en SVG zijn toegestaan.',
            tooLarge: 'Bestand te groot. Maximale grootte is 2MB.',
            uploadFailed: 'Logo uploaden mislukt. Probeer het opnieuw.',
            deleteFailed: 'Logo verwijderen mislukt. Probeer het opnieuw.',
            confirmDelete: 'Weet je zeker dat je je logo wilt verwijderen?',
            loginRequired: 'Je moet ingelogd zijn om een logo te uploaden'
        },
        invoiceNumber: {
            title: 'Factuurnummer Formaat',
            preview: 'Volgende factuur wordt',
            prefix: 'Voorvoegsel',
            prefixPlaceholder: 'bijv. FACT',
            includeYear: 'Jaar Toevoegen',
            yearFormat: 'Jaar Formaat',
            yearFormatFull: 'Volledig Jaar',
            yearFormatShort: 'Kort Jaar',
            separator: 'Scheidingsteken',
            noSeparator: 'Geen',
            numberPadding: 'Nummer Lengte',
            numberPaddingHelp: 'Lengte van het volgnummer',
            resetToDefault: 'Standaard Herstellen'
        },
        languageNotice: 'Je interface is in het {interfaceLanguage}, maar facturen worden verzonden in het {invoiceLanguage}. Zie e-mailvoorbeeld.'
    },
    dialog: {
        deleteInvoice: {
            title: 'Factuur verwijderen',
            message: 'Weet u zeker dat u deze factuur wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
        },
        deleteCompany: {
            title: 'Bedrijf verwijderen',
            message: 'Weet u zeker dat u dit bedrijf wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
        },
        saveSuccess: {
            title: 'Factuur opgeslagen!',
            message: 'Uw factuur is succesvol opgeslagen.',
            newInvoice: 'Nieuwe Factuur',
            viewInvoice: 'Factuur Bekijken',
        },
    },
    placeholders: {
        enterPaymentTerms: 'Voer betalingstermijn in',
        dueDateWillBe: 'Vervaldatum wordt {date}',
        pastDateWarning: 'Deze datum ligt in het verleden',
        addDetails: 'Vul uw gegevens in',
    },
    paymentTerms: {
        '7 days': '7 dagen',
        '14 days': '14 dagen',
        '30 days': '30 dagen',
        '60 days': '60 dagen',
        'Due on receipt': 'Direct te betalen'
    },
    landing: {
        title: 'Direct facturen. Helemaal gratis.',
        headerTitle: 'InvoiceHappens',
        subtitle: '100% gratis voor de eerste 100.000 ondernemers Start nu hieronder',
        madeBy: 'gemaakt door @sanderbz',
        invoiceNumber: 'Factuurnummer: {number}',
        tagline: '*poef* een factuur',
        contact: 'Neem Contact Op',
        getInTouch: 'Kom in Contact',
        contactDescription: 'Heeft u vragen of hulp nodig? Wij staan voor u klaar. Neem contact op met ons team via een van de onderstaande methoden.',
        joinCommunity: 'Word Lid van Onze Community',
        communityDescription: 'Volg ons op sociale media om op de hoogte te blijven van de nieuwste functies, tips en nieuws over InvoiceHappens.'
    },
    overview: {
        title: 'Je facturen',
        emptyTitle: 'Nog geen facturen',
        emptyDescription: 'Je facturen verschijnen hier. Begin met het maken van een nieuwe factuur.',
        emptyFilterDescriptions: {
            all: 'Je facturen verschijnen hier. Begin met het maken van een nieuwe factuur.',
            unpaid: 'Geen openstaande facturen gevonden. Al je facturen zijn betaald!',
            paid: 'Nog geen betaalde facturen gevonden.',
            overdue: 'Geen achterstallige facturen gevonden. Goed bezig met het bijhouden van betalingen!',
            overdue_reminded: 'Geen herinnerde facturen gevonden.',
        },
        totalCount: '{count} {count, plural, one {factuur} other {facturen}} totaal'
    },
    company: {
        saveAsDefault: 'Opslaan als standaard',
        useAsFrom: 'Gebruik als Afzender',
        editDetails: 'Bedrijfsgegevens Bewerken',
        yourCompany: 'Uw Bedrijf',
        name: 'Bedrijfsnaam',
        address: 'Adres',
        city: 'Plaats',
        contactName: 'Contactpersoon',
        createdAt: 'Aangemaakt op',
        createNew: 'Nieuw bedrijf aanmaken: {name}',
        noResults: 'Geen bedrijven gevonden',
        recentCompanies: 'Recente bedrijven',
        noRecentCompanies: 'Geen recente bedrijven gevonden',
        select: 'Selecteer een bedrijf',
        creating: 'Bedrijf aanmaken...',
        created: 'Bedrijf aangemaakt!',
        clearSelection: 'Bedrijfsselectie wissen',
    },
    auth: {
        welcome: 'Werk Opslaan',
        signInToContinue: 'Verbind om je facturen in de cloud op te slaan',
        continueWithGoogle: 'Doorgaan met Google',
        continueWithMicrosoft: 'Doorgaan met Microsoft',
        privacyNotice: 'Door door te gaan ga je akkoord met onze Servicevoorwaarden en Privacybeleid',
        signOut: 'Uitloggen',
        user: 'Gebruiker',
        signIn: 'Inloggen of Registreren',
        secureTitle: 'Beveilig Je Werk',
        secureDescription: 'Houd je facturen veilig en overal toegankelijk. Verbind om ervoor te zorgen dat je werk automatisch wordt opgeslagen en nooit verloren gaat, zelfs niet als je je browsergegevens wist.',
        autoSave: 'Automatische cloud backup',
        browserWarning: 'Beschermd tegen gegevensverlies',
        signedInAs: 'Verbonden als',
        browserOnly: 'Alleen browser',
        clearCacheWarning: 'Cache wissen = data kwijt',
        neverLoseWork: 'Raak nooit werk kwijt',
        autoSaveCloud: 'Auto-save naar cloud',
        freeAccount: 'Het is volledig gratis!',
        welcomeBar: {
            title: 'Al eerder facturen gemaakt?',
            description: 'Log in om je opgeslagen facturen op dit apparaat te bekijken',
            signIn: 'Inloggen'
        },
        loginRequired: {
            logo: {
                title: 'Upload Je Logo',
                description: 'Je moet inloggen om je bedrijfslogo te uploaden en op te slaan.'
            },
            mollie: {
                title: 'Verbind met Mollie',
                description: 'Je moet inloggen om te verbinden met Mollie voor online betalingen.'
            },
            email: {
                title: 'Verstuur Facturen via E-mail',
                description: 'Je moet inloggen om facturen via e-mail naar je klanten te versturen.'
            }
        }
    },
    admin: {
        menuItem: 'Beheerders Dashboard',
        title: 'Beheerders Dashboard',
        backToHome: 'Terug naar Home',
        backToUsers: 'Terug naar Gebruikers',
        backToAdmin: 'Terug naar Beheerder',
        backToInvoices: 'Terug naar Facturen',
        lastChanged: 'Laatst gewijzigd {time}',
        invoiceDetails: {
            title: 'Factuur {number}',
            subtitle: 'Gemaakt door {email}',
            rawData: 'Ruwe Data'
        },
        emails: {
            title: 'E-mail Wachtrij',
            queueTitle: 'Recente E-mails',
            viewQueue: 'Bekijk E-mail Wachtrij',
            refresh: 'Vernieuwen',
            total: 'Totaal E-mails',
            planned: 'Gepland',
            sent: 'Verzonden',
            invoiceNumber: 'Factuur',
            user: 'Gebruiker',
            recipient: 'Ontvanger',
            status: {
                sent: 'Verzonden',
                planned: 'Gepland',
                failed: 'Mislukt'
            },
            scheduled: 'Gepland Op',
            attempts: 'Pogingen'
        },
        users: {
            title: 'Gebruikers',
            email: 'E-mail',
            company: 'Bedrijf',
            invoices: 'Facturen',
            joined: 'Lid sinds',
            lastActive: 'Laatst actief',
            actions: 'Acties',
            viewInvoices: 'Facturen',
            viewCompanies: 'Bedrijven',
            viewSettings: 'Instellingen',
            viewSchedules: 'Schema\'s',
            settings: 'Gebruikersinstellingen',
            noSettings: 'Geen instellingen gevonden',
            activeToday: 'Vandaag Actief',
            totalInvoices: 'Totaal Facturen'
        },
        userInvoices: {
            title: 'Facturen voor {email}',
            invoices: 'Facturen',
            noInvoices: 'Geen facturen gevonden',
            loadMore: 'Meer laden',
            previewEmail: 'E-mail voorbeeld',
            emailPreview: 'E-mail voorbeeld voor factuur {invoiceNumber}',
            loadingEmail: 'E-mail voorbeeld laden...'
        },
        userCompanies: {
            title: 'Bedrijven van {email}',
            companies: 'Bedrijven',
            noCompanies: 'Geen bedrijven gevonden'
        },
        userSchedules: {
            title: 'Schema\'s van {email}',
            schedules: 'Schema\'s',
            noSchedules: 'Geen schema\'s gevonden',
            templateInvoice: 'Sjabloon Factuur',
            type: 'Type',
            startDate: 'Startdatum',
            endDate: 'Einddatum',
            lastGenerated: 'Laatst Gegenereerd',
            nextDate: 'Volgende Datum',
            status: 'Status',
            active: 'Actief',
            inactive: 'Inactief'
        }
    },
    common: {
        loading: 'Laden...',
        refresh: 'Vernieuwen',
        refreshing: 'Vernieuwen...',
        error: 'Er is een fout opgetreden',
        yes: 'Ja',
        no: 'Nee',
        close: 'Sluiten',
        actions: 'Acties',
        now: 'Nu'
    },
    email: {
        sendInvoice: 'Factuur verzenden',
        previewText: 'Factuur #{invoiceNumber} van {company} - Gereed voor inzage',
        subject: 'Factuur #{invoiceNumber} van {company}',
        recipientEmail: 'E-mailadres ontvanger',
        contactName: 'Contactpersoon',
        contactNamePlaceholder: 'Naam contactpersoon',
        messageLabel: 'Persoonlijk bericht',
        messagePlaceholder: 'Voeg een persoonlijk bericht toe aan je factuur e-mail...',
        invalidEmail: 'Voer een geldig e-mailadres in',
        previewTitle: 'E-mail voorbeeld',
        send: 'Verzenden',
        greeting: 'Beste',
        defaultMessage: 'Bedankt voor het kiezen van {company}. Bijgevoegd vindt u uw factuur ({invoiceNumber}).\n\nMet vriendelijke groet,\n{company}',
        reminderSubject: 'Betalingsherinnering: Factuur #{invoiceNumber} van {company}',
        reminderHeader: 'Dit is een vriendelijke herinnering dat de betaling voor deze factuur achterstallig is.',
        reminderDefaultMessage: 'Dit is een vriendelijke herinnering dat factuur {invoiceNumber} van {company} nu achterstallig is. Wij verzoeken u vriendelijk om de betaling zo spoedig mogelijk te verwerken.\n\nAls u de betaling al heeft gedaan, kunt u dit bericht negeren.\n\nBedankt voor uw aandacht voor deze kwestie.\n\nMet vriendelijke groet,\n{company}',
        history: 'Geschiedenis',
        success: {
            title: 'Factuur verzonden!',
            description: 'Je factuur is succesvol verzonden naar {email}'
        },
        reminderSuccess: {
            title: 'Herinnering verzonden!',
            description: 'Betalingsherinnering is verzonden naar {email}'
        },
        reminderCooldownError: 'Je kunt de volgende herinnering versturen {time}',
        reminderTooSoon: 'Herinnering is recentelijk verzonden. Wacht 24 uur tussen herinneringen.'
    },
    emailHistory: {
        queued: 'E-mail in wachtrij',
        sent: 'E-mail verzonden',
        failed: 'E-mail mislukt',
        reminderQueued: 'Herinnering in wachtrij',
        reminderSent: 'Herinnering verzonden',
        to: 'Aan: {email}',
        failedDescription: 'Aan: {email}{error, select, false {} other { - {error}}}'
    },
    period: {
        title: 'Periode',
        custom: 'Aangepaste periode',
        selectDates: 'Selecteer datumbereik',
        apply: 'Toepassen',
        presets: {
            title: 'Voorinstellingen',
            currentMonth: 'Huidige maand',
            previousMonth: 'Vorige maand',
            currentQuarter: 'Huidig kwartaal',
            previousQuarter: 'Vorig kwartaal',
            currentYear: 'Huidig jaar',
            previousYear: 'Vorig jaar',
            last30Days: 'Laatste 30 dagen',
            last90Days: 'Laatste 90 dagen',
            yearToDate: 'Jaar tot nu toe',
            today: 'Vandaag',
            yesterday: 'Gisteren',
            last7days: 'Laatste 7 dagen',
            last30days: 'Laatste 30 dagen',
            thisMonth: 'Deze maand',
            lastMonth: 'Vorige maand',
            thisQuarter: 'Dit kwartaal',
            lastQuarter: 'Vorig kwartaal',
            thisYear: 'Dit jaar',
            lastYear: 'Vorig jaar'
        },
        month: 'Maand',
        currentMonth: 'Huidige Maand',
        previousMonth: 'Vorige Maand'
    },
    schedule: {
        title: 'Terugkerende Planning',
        create: 'Maak Terugkerend',
        edit: 'Bewerk Planning',
        type: 'Frequentie',
        monthly: 'Maandelijks',
        quarterly: 'Per Kwartaal',
        yearly: 'Jaarlijks',
        day: 'Dag',
        dayOfMonth: 'van de maand',
        dayHelp: 'Als de dag de dagen van de maand overschrijdt, wordt de laatste dag gebruikt.',
        dayError: 'Dag moet tussen 1 en 31 liggen',
        dayFromStartDate: 'Zal terugkeren op dag {day} van elke periode',
        dateSync: 'Dit is ook de factuurdatum',
        startDate: 'Startdatum',
        endDate: 'Einddatum',
        optional: 'optioneel',
        endDateError: 'Einddatum moet na startdatum liggen',
        nextInvoice: 'Volgende factuur',
        until: 'Tot',
        description: '{type} op dag {day}',
        notScheduled: 'Niet gepland',
        clickToSetup: 'Klik om terugkerend in te stellen',
        confirmDelete: 'Weet je zeker dat je dit schema wilt verwijderen?',
        scheduled: 'Gepland',
    },
    navigation: {
        features: 'Functies',
        pricing: 'Prijzen',
        contact: 'Contact',
        login: 'Inloggen',
    },
    footer: {
        about: 'Over ons',
        resources: 'Bronnen',
        account: 'Account',
        support: 'Ondersteuning',
        blog: 'Blog',
        faq: 'FAQ',
        login: 'Inloggen',
        feedback: 'Bugs & Feedback',
        privacyPolicy: 'Privacybeleid',
        termsOfService: 'Servicevoorwaarden',
        copyright: '© {year} {company}. Alle rechten voorbehouden.',
        backToTop: 'Terug naar boven',
    },
    easySection: {
        title: 'Factureren gemakkelijk gemaakt',
        subtitle: 'Maak moeiteloos mooie facturen, laat de complexiteit aan ons over.',
        oneClickInvoice: {
            title: 'Factuur met één klik',
            description: 'Maak je factuur in seconden, met onze intuïtieve interface en generatie met één klik.'
        },
        intuitiveWorkflow: {
            title: 'Een professionele indruk',
            description: 'Met onze mooie facturen kun je eenvoudig je facturen beheren zonder ingewikkelde stappen of boekhoudkundige kennis.'
        },
        paymentOptions: {
            title: 'Alle betaalmethoden',
            description: 'Ondersteuning voor alle belangrijke betaalmethoden, waaronder creditcards, Apple Pay, iDeal, Klarna, SEPA, PayPal en meer.'
        },
        cloudSync: {
            title: 'Alle facturen op één plek',
            description: 'Toegang tot je facturen vanaf elke locatie met onze veilige cloudopslag. Raak nooit meer een belangrijk document kwijt.'
        }
    },
    faq: {
        title: 'Veelgestelde vragen',
        subtitle: 'We zijn er om je te helpen met al je vragen. Als je niet vindt wat je zoekt, bezoek dan onze',
        completeFaqLink: 'complete FAQ-pagina'
    },
    seo: {
        defaultTitle: 'InvoiceHappens - Maak Direct Mooie Facturen',
        defaultDescription: 'Maak en verstuur professionele facturen binnen enkele seconden zonder aanmeldingen en zonder kosten. Het elegante factureringsplatform voor ondernemers.',
        home: {
            title: 'InvoiceHappens - Maak Direct Mooie Facturen',
            description: 'Maak en verstuur professionele facturen binnen enkele seconden zonder aanmeldingen en zonder kosten. Het elegante factureringsplatform voor ondernemers.'
        },
        features: {
            title: 'Functies - InvoiceHappens',
            description: 'Ontdek de krachtige functies van InvoiceHappens: directe factuurcreatie, prachtige sjablonen, cloudsynchronisatie en meer.'
        },
        pricing: {
            title: 'Prijzen - InvoiceHappens',
            description: 'Eenvoudige, transparante prijzen zonder verborgen kosten. Begin vandaag nog gratis met factureren.'
        },
        contact: {
            title: 'Contact - InvoiceHappens',
            description: 'Heb je vragen of feedback? Neem contact op met ons team. We zijn er om te helpen.'
        },
        faq: {
            title: 'Veelgestelde Vragen - InvoiceHappens',
            description: 'Vind antwoorden op veelgestelde vragen over InvoiceHappens, onze functies, prijzen en meer.'
        },
        termsOfService: {
            title: 'Servicevoorwaarden - InvoiceHappens',
            description: 'Lees onze servicevoorwaarden om de regels en richtlijnen voor het gebruik van InvoiceHappens te begrijpen.'
        },
        privacyPolicy: {
            title: 'Privacybeleid - InvoiceHappens',
            description: 'Lees hoe we je persoonlijke gegevens verzamelen, gebruiken en beschermen bij InvoiceHappens.'
        },
        invoiceStatus: {
            title: 'Factuurstatus - InvoiceHappens',
            description: 'Controleer de status van je factuur en betalingsinformatie.'
        }
    },
    notFound: {
        title: 'Pagina Niet Gevonden',
        message: 'De pagina die je zoekt bestaat niet of is verplaatst.',
        backHome: 'Terug naar Home'
    },
};
